import { take, put, select, spawn } from 'redux-saga/effects'
import { StateReducers } from 'state/reducers/types/StateReducers'
import { selectState } from 'state/reducers/selectState'
import { getCurrentQuery } from 'state/getters/getCurrentQuery'
import { getCurrentTeamId } from 'state/getters/getCurrentTeamId'
import { TasksReducer } from 'state/reducers/types/TasksReducer'
import { createUnexpectedErrorAction } from 'actionCreators/createUnexpectedErrorAction'
import {
  SUBMIT_WORKING_ON_TASK_SUMMARY,
  SUBMIT_WORKING_ON_TASK_SUMMARY_DONE,
} from 'actions'
import { SubmitAction } from 'actionCreators/submit/Submit/types/SubmitAction'

import { patchTasksSaga } from 'flows/sagas/patch/patchTasksSaga'
import { clientServerTimestamp } from 'sdks'

export const submitWorkingOnTaskSummaryF = function*() {
  while (1) {
    const action: SubmitAction = yield take([SUBMIT_WORKING_ON_TASK_SUMMARY])
    const working = action.values.working
    const state: StateReducers = yield select(selectState)
    const currentUserId = state.currentUserId
    const query = getCurrentQuery({ state })
    const taskId = query && query.taskId
    const teamId = getCurrentTeamId({ state })

    if (taskId && teamId && currentUserId) {
      const items: TasksReducer = {
        [taskId]: {
          data: {
            workingOnSummary: working
              ? {
                  userId: currentUserId,
                  updated: clientServerTimestamp(),
                }
              : null,
          },
          teamId,
        },
      }

      yield spawn(patchTasksSaga, {
        items: items,
        lastModifiedUserId: 'skip',
        lastModifiedDisplayName: 'skip',
      })
    } else {
      yield put(
        createUnexpectedErrorAction({
          description: 'submitWorkingOnTaskSummaryF',
          // silent: true, // Failure is caused by debounced method executing after cpu sleeps
        })
      )
    }

    yield put({
      type: SUBMIT_WORKING_ON_TASK_SUMMARY_DONE,
    })
  }
}
